import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const PROBLEMS = [
    {
        title: 'Stuck at the Same Score',
        description: "You've taken multiple tests but keep getting Band 6.5-7. Without understanding exactly what's wrong, improvement feels impossible.",
    },
    {
        title: 'Mocks Without Meaningful Feedback',
        description: "Taking practice tests repeatedly doesn't help if you don't know precisely why you're losing marks and what specific changes to make.",
    },
    {
        title: "Generic Coaching Isn't Enough",
        description: "Advanced learners don't need grammar basics. You need targeted, personalized insights that address your specific weak areas.",
    },
];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '72px 64px',
        [theme.breakpoints.down('md')]: {
            padding: '48px 24px',
        },
    },
    heading: {
        color: '#FFFFFF',
        fontFamily: 'Mulish, sans-serif',
        fontWeight: 800,
        fontSize: '2.5rem',
        lineHeight: 1.25,
        marginBottom: '16px',
        [theme.breakpoints.down('md')]: {
            fontSize: '1.8rem',
        },
    },
    subtitle: {
        color: '#E6E6E6',
        fontFamily: 'Mulish, sans-serif',
        fontStyle: 'italic',
        fontSize: '0.875rem',
        lineHeight: 1.75,
        textAlign: 'center',
        marginBottom: '48px',
    },
    problemRow: {
        display: 'flex',
        gap: '32px',
        padding: '28px 0',
        alignItems: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '10px',
        },
    },
    problemTitle: {
        flex: '0 0 36%',
        color: '#FFFFFF',
        fontFamily: 'Mulish, sans-serif',
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: 1.45,
        [theme.breakpoints.down('sm')]: {
            flex: 'unset',
        },
    },
    problemDesc: {
        flex: 1,
        color: '#E6E6E6',
        fontFamily: 'Mulish, sans-serif',
        fontSize: '0.875rem',
        lineHeight: 1.75,
    },
    divider: {
        borderColor: 'rgba(255,255,255,0.1)',
    },
}));

function WhyStuck() {
    const classes = useStyles();

    return (
        <Box className={classes.root}>

            {/* Heading */}
            <Typography className={classes.heading}>
                Why Do Good English Speakers Get Stuck at Band 6.5?
            </Typography>

            {/* Italic subtitle — centered below heading */}
            <Typography className={classes.subtitle}>
                You know English well. The problem isn't your language skills – it's the
                gap between knowing English and knowing what IELTS examiners actually want.
            </Typography>

            {/* Problem rows — stacked vertically */}
            {PROBLEMS.map((problem) => (
                <React.Fragment key={problem.title}>
                    <Box className={classes.problemRow}>
                        <Typography className={classes.problemTitle}>
                            {problem.title}
                        </Typography>
                        <Typography className={classes.problemDesc}>
                            {problem.description}
                        </Typography>
                    </Box>
                    <Divider className={classes.divider} />
                </React.Fragment>
            ))}

        </Box>
    );
}

export default WhyStuck;
